/**
 * 推荐分成相关组件
 * */
// 推荐分成攻略
Vue.component(
    'tips-recommand',
    resolve => require(["../../components/tips/recommand"], resolve)
);
// 推荐分成列表
Vue.component(
    'tips-list',
    resolve => require(["../../components/tips"], resolve)
);
// 推荐分成弹窗
Vue.component(
    'tips-alert',
    resolve => require(["../../components/tips/alert"], resolve)
);
// 推荐分成广告
Vue.component(
    'tips-ad',
    resolve => require(["../../components/tips/ad"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/tips.js